import React from "react";
import AdminRawMaterials from "../../components/admin/components/AdminRawMaterials";

const RawMaterials = () => {
  return <AdminRawMaterials />;
};

export default RawMaterials;
